export enum MaterialTypeEnum {
  MARBLE = 'MERMER',
  QUARTZ = 'KVARC',
  GRANITE = 'GRANIT',
  ONYX = 'ONIKS',
  TRAVERTINE = 'TRAVERTIN',
  QUARZITE = 'KVARCIT',
  PESCAR = 'PESCAR',
  KERAMIKA = 'KERAMIKA',
  VESTAK = 'VESTAK',
  KRECNJAK = 'KRECNJAK',
}
